import React, { useState } from "react";

const ISP_HeroSection = () => {
  // State to handle zip code input
  const [zipCode, setZipCode] = useState("");

  const handleCheck = (e) => {
    e.preventDefault();
    alert(`Checking availability for zip code: ${zipCode}`);
  };

  return (
    <section className="relative py-20 flex items-center justify-center bg-slate-950 text-white overflow-hidden">
      {/* --- Animated Background Effects --- */}
      {/* Abstract circles representing "signal waves" or data flow */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan-600/20 rounded-full blur-[100px] animate-pulse"></div>
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-blue-600/20 rounded-full blur-[100px] animate-pulse delay-1000"></div>

      {/* Grid Pattern overlay for "Tech" feel */}
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "linear-gradient(#334155 1px, transparent 1px), linear-gradient(to right, #334155 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      ></div>

      <div className="container mx-auto px-6 relative z-10 text-center max-w-5xl">
        {/* --- Badge / Trust Indicator --- */}
        <span className="inline-block py-1 px-4 rounded-full bg-cyan-500/10 border border-cyan-500/30 text-white text-xs font-bold uppercase tracking-widest mb-8 backdrop-blur-sm">
          The Future of Connection
        </span>

        {/* --- Main Headline --- */}
        <h1 className="text-5xl md:text-8xl font-bold mb-6 tracking-tight leading-tight">
          Internet at the <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-blue-500 to-indigo-500">
            Speed of Light
          </span>
        </h1>

        <p className="text-lg md:text-xl text-slate-400 mb-12 max-w-2xl mx-auto">
          Experience ultra-low latency and lightning-fast download speeds with
          our fiber-optic network. Built for gaming, streaming, and business.
        </p>

        {/* --- Speed Stats (Optional decorative element) --- */}
        <div className="mt-16 flex justify-center gap-8 md:gap-16 text-slate-500 text-sm font-mono uppercase tracking-widest">
          <div className="text-center">
            <span className="block text-2xl md:text-3xl text-white font-bold">
              1Mbps to 1000 Mbps
            </span>
            <span>Download</span>
          </div>
          <div className="text-center">
            <span className="block text-2xl md:text-3xl text-white font-bold">
              5ms
            </span>
            <span>Latency</span>
          </div>
          <div className="text-center">
            <span className="block text-2xl md:text-3xl text-white font-bold">
              99.9%
            </span>
            <span>Uptime</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ISP_HeroSection;
